import About from './about';
import Locale from './locale';
import Image from './image';
import Description from './description';
import TermsAndConditions from './termsAndConditions';

export{
  About,
  Locale,
  Image,
  Description,
  TermsAndConditions,
}